import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { Templates_Get_All, Templates_Initialize, Templates_Update } from '../api/API_Templates';
import { useStatus } from "./Context_Status_Global";
const Context_Templating = createContext();

export default function Context_Provider_Templating({ children }) {
    const [Template_Editor_Unsaved, Template_Editor_Unsaved_Set] = useState(false);
    const [Template_List, Template_List_Set] = useState([]);
    const { List_Unsaved, List_Unsaved_Set, Status_Saving_Set, Status_Fetching_Set, Confirmer_Confirm } = useStatus();

    useEffect(() => {
        Templates_Load();
    }, []);

    // useEffect(() => {
    //     console.log(Template_Editor_Unsaved);
    // }, [Template_Editor_Unsaved])


    /*useEffect(() => {
        List_Unsaved_Set(prev => {
            const alreadyHas = prev.includes("System Templating");

            if (Template_Editor_Unsaved && !alreadyHas) {
                return [...prev, "System Templating"];
            }

            if (!Template_Editor_Unsaved && alreadyHas) {
                return prev.filter(item => item !== "System Templating");
            }

            return prev;
        });
    }, [Template_Editor_Unsaved, List_Unsaved_Set]);*/

    const Templates_Load = async () => {
        Status_Fetching_Set("InProgress");
        const Response = await Templates_Get_All();
        if (Response.data.length == 0) {
            console.warn("Empty response");
            await Templates_Initialize()
                .catch(Error => {
                    if (Error.response && Error.response.status === 409) {
                        console.info("Skip.");
                    } else {
                        console.error("Error.");
                    }
                });
            const Response_Retry = await Templates_Get_All();
            Template_List_Set(Response_Retry.data[0]);
            Status_Fetching_Set("Success");
            // window.Toasts_CreateToast("https://bhimlex13.github.io/Student-Assistant-Portal/Assets/Icons/Logo.png", "Template initialized", "It worked.");
        } else {
            Template_List_Set(Response.data[0]);
            // window.Toasts_CreateToast("https://bhimlex13.github.io/Student-Assistant-Portal/Assets/Icons/Logo.png", "Template loaded", "It worked.");
            // console.log("Templates loaded");
            Status_Fetching_Set("Success");
        }
    }

    const Templates_Save = async (Template) => {
        Status_Saving_Set("InProgress");
        // console.log("Saving (fresh):", Template);
        try {
            const Response = await Templates_Update(Template);
            // console.log(Response.data);
            Status_Saving_Set("Success");
        } catch (Error) {
            console.error("Error:", Error);
            Status_Saving_Set("Error");
        }
    }




    const Templates_Edit_Save = async () => {
        Status_Saving_Set("InProgress");
        const Updated = [...Template_List];
        // console.log("Attempting to save", Updated);
        try {
            await Templates_Update(Updated[0]);
            // await Templates_Load();
            Template_Editor_Unsaved_Set(false);
            List_Unsaved_Set(prev => {
                const alreadyHas = prev.includes("System Templating");

                if (!Template_Editor_Unsaved && alreadyHas) {
                    return prev.filter(item => item !== "System Templating");
                }

                return prev;
            });
            Status_Saving_Set("Success");
        } catch (Error) {
            console.error("Error: " + Error);
            Status_Saving_Set("Error");
        }
    }

    const Templates_Edit_Save_Attempt = () => {
        // console.log("Attempting to save.", Template_List);
    }

    const Path_Get = (Data, Path) => {
        return Path.split('.').reduce((acc, key) => acc && acc[key], Data);
    }

    const Templates_Add = (Path) => {
        let Templates_Updated = { ...Template_List };
        const List = Path_Get(Templates_Updated, Path);
        List.push("");
        Templates_Save(Templates_Updated);
        Template_List_Set(Templates_Updated);
        return List.length + 1;
    }

    const Templates_Edit = (Path, Type, Index, Value) => {
        if (Type && Index !== null) {
            const Templates_Updated = { ...Template_List };
            let List = Path_Get(Templates_Updated, Path);
            List[Index] = Value;
            Templates_Save(Templates_Updated);
            Template_List_Set(Templates_Updated);
        }
    }

    const Templates_Delete = (Path, Index) => {
        const Templates_Updated = { ...Template_List };
        let List = Path_Get(Templates_Updated, Path);
        if (Array.isArray(List)) {
            List.splice(Index, 1);
        }
        Templates_Save(Templates_Updated);
        Template_List_Set(Templates_Updated);
    }

    const Templates_RoomType_Add = () => {
        const Templates_Updated = { ...Template_List };
        let List = Templates_Updated.RoomType;
        List.push({
            Name: "TESUTO",
            hasDefinedHours: false,
            DefinedHours: [
                {
                    Day: "SUN",
                    hasDefinedHours: true,
                    Start: new Date(new Date().setHours(6, 0, 0, 0)),
                    End: new Date(new Date().setHours(17, 0, 0, 0))
                },
                {
                    Day: "MON",
                    hasDefinedHours: true,
                    Start: new Date(new Date().setHours(6, 0, 0, 0)),
                    End: new Date(new Date().setHours(17, 0, 0, 0))
                },
                {
                    Day: "TUE",
                    hasDefinedHours: true,
                    Start: new Date(new Date().setHours(6, 0, 0, 0)),
                    End: new Date(new Date().setHours(17, 0, 0, 0))
                },
                {
                    Day: "WED",
                    hasDefinedHours: true,
                    Start: new Date(new Date().setHours(6, 0, 0, 0)),
                    End: new Date(new Date().setHours(17, 0, 0, 0))
                },
                {
                    Day: "THU",
                    hasDefinedHours: true,
                    Start: new Date(new Date().setHours(6, 0, 0, 0)),
                    End: new Date(new Date().setHours(17, 0, 0, 0))
                },
                {
                    Day: "FRI",
                    hasDefinedHours: true,
                    Start: new Date(new Date().setHours(6, 0, 0, 0)),
                    End: new Date(new Date().setHours(17, 0, 0, 0))
                },
                {
                    Day: "SAT",
                    hasDefinedHours: true,
                    Start: new Date(new Date().setHours(6, 0, 0, 0)),
                    End: new Date(new Date().setHours(17, 0, 0, 0))
                },
            ]
        });
        Templates_Save(Templates_Updated);
        Template_List_Set(Templates_Updated);
        return List.length + 1;
    }

    const Templates_RoomType_Edit = (Type, Index, Value) => {
        if (Type && Index !== null) {
            const Templates_Updated = { ...Template_List };
            let List = Templates_Updated.RoomType;
            List[Index].Name = Value;
            Templates_Save(Templates_Updated);
            Template_List_Set(Templates_Updated);
        }
    }

    const Templates_RoomType_ToggleHasHours = (Index, State) => {
        const Templates_Updated = { ...Template_List };
        let State_New = false;
        if (State === "Active") {
            State_New = true;
        } else {
            State_New = false;
        }
        let List = Templates_Updated.RoomType;
        List[Index].hasDefinedHours = State_New;
        Templates_Save(Templates_Updated);
        Template_List_Set(Templates_Updated);
    }

    const Templates_RoomType_ToggleHasAircon = (Index, State) => {
        const Templates_Updated = { ...Template_List };
        let State_New = false;
        if (State === "Active") {
            State_New = true;
        } else {
            State_New = false;
        }
        let List = Templates_Updated.RoomType;
        List[Index].hasAirconditioner = State_New;
        Templates_Save(Templates_Updated);
        Template_List_Set(Templates_Updated);
    }

    const [Template_RoomType_EditData, Template_RoomType_EditData_Set] = useState(null);

    const Templates_RoomType_EditHours = async (Index) => {
        console.warn(Template_List.RoomType[Index]);
        Template_RoomType_EditData_Set(Template_List.RoomType[Index]);
        const { Response, Data } = await Confirmer_Confirm("Window_Templating_EditBlockedHours");
        if (Response === "Confirmed") {
            const Templates_Updated = { ...Template_List };
            let RoomType = Templates_Updated.RoomType[Index];
            RoomType = Data;
            Templates_Save(Templates_Updated);
            Template_List_Set(Templates_Updated);
        }
    }

    return (
        <Context_Templating.Provider value={{
            Template_Editor_Unsaved,
            Template_Editor_Unsaved_Set,
            Template_List,
            Template_List_Set,
            Templates_Load,
            Templates_Edit_Save,
            Templates_Edit_Save_Attempt,
            Templates_Add,
            Templates_Edit,
            Templates_Delete,
            Templates_RoomType_Add,
            Templates_RoomType_Edit,
            Templates_RoomType_ToggleHasHours,
            Templates_RoomType_ToggleHasAircon,
            Templates_RoomType_EditHours,
            Template_RoomType_EditData,
            Template_RoomType_EditData_Set
        }}>
            {children}
        </Context_Templating.Provider>
    )
}

export function useTemplating() {
    return useContext(Context_Templating);
}